/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppUsedToolDetailsRouteImport } from './routes/_app/used-tool-details'
import { Route as AppToolsRouteImport } from './routes/_app/tools'
import { Route as AppStatusRouteImport } from './routes/_app/status'
import { Route as AppRackToolDetailsRouteImport } from './routes/_app/rack-tool-details'
import { Route as AppQueuedJobDetailsRouteImport } from './routes/_app/queued-job-details'
import { Route as AppMillingJobsRouteImport } from './routes/_app/milling-jobs'
import { Route as AppMagazineSlotDetailsRouteImport } from './routes/_app/magazine-slot-details'
import { Route as AppLibraryToolDetailsRouteImport } from './routes/_app/library-tool-details'
import { Route as AppLibraryBlankDetailsRouteImport } from './routes/_app/library-blank-details'
import { Route as AppExecutedJobDetailsRouteImport } from './routes/_app/executed-job-details'
import { Route as AppBlanksRouteImport } from './routes/_app/blanks'
import { Route as AppActiveJobDetailsRouteImport } from './routes/_app/active-job-details'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsedToolDetailsRoute = AppUsedToolDetailsRouteImport.update({
  id: '/used-tool-details',
  path: '/used-tool-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppToolsRoute = AppToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStatusRoute = AppStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRackToolDetailsRoute = AppRackToolDetailsRouteImport.update({
  id: '/rack-tool-details',
  path: '/rack-tool-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppQueuedJobDetailsRoute = AppQueuedJobDetailsRouteImport.update({
  id: '/queued-job-details',
  path: '/queued-job-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMillingJobsRoute = AppMillingJobsRouteImport.update({
  id: '/milling-jobs',
  path: '/milling-jobs',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMagazineSlotDetailsRoute = AppMagazineSlotDetailsRouteImport.update({
  id: '/magazine-slot-details',
  path: '/magazine-slot-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLibraryToolDetailsRoute = AppLibraryToolDetailsRouteImport.update({
  id: '/library-tool-details',
  path: '/library-tool-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLibraryBlankDetailsRoute = AppLibraryBlankDetailsRouteImport.update({
  id: '/library-blank-details',
  path: '/library-blank-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExecutedJobDetailsRoute = AppExecutedJobDetailsRouteImport.update({
  id: '/executed-job-details',
  path: '/executed-job-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBlanksRoute = AppBlanksRouteImport.update({
  id: '/blanks',
  path: '/blanks',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppActiveJobDetailsRoute = AppActiveJobDetailsRouteImport.update({
  id: '/active-job-details',
  path: '/active-job-details',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/active-job-details': typeof AppActiveJobDetailsRoute
  '/blanks': typeof AppBlanksRoute
  '/executed-job-details': typeof AppExecutedJobDetailsRoute
  '/library-blank-details': typeof AppLibraryBlankDetailsRoute
  '/library-tool-details': typeof AppLibraryToolDetailsRoute
  '/magazine-slot-details': typeof AppMagazineSlotDetailsRoute
  '/milling-jobs': typeof AppMillingJobsRoute
  '/queued-job-details': typeof AppQueuedJobDetailsRoute
  '/rack-tool-details': typeof AppRackToolDetailsRoute
  '/status': typeof AppStatusRoute
  '/tools': typeof AppToolsRoute
  '/used-tool-details': typeof AppUsedToolDetailsRoute
}
export interface FileRoutesByTo {
  '/': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/active-job-details': typeof AppActiveJobDetailsRoute
  '/blanks': typeof AppBlanksRoute
  '/executed-job-details': typeof AppExecutedJobDetailsRoute
  '/library-blank-details': typeof AppLibraryBlankDetailsRoute
  '/library-tool-details': typeof AppLibraryToolDetailsRoute
  '/magazine-slot-details': typeof AppMagazineSlotDetailsRoute
  '/milling-jobs': typeof AppMillingJobsRoute
  '/queued-job-details': typeof AppQueuedJobDetailsRoute
  '/rack-tool-details': typeof AppRackToolDetailsRoute
  '/status': typeof AppStatusRoute
  '/tools': typeof AppToolsRoute
  '/used-tool-details': typeof AppUsedToolDetailsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/active-job-details': typeof AppActiveJobDetailsRoute
  '/_app/blanks': typeof AppBlanksRoute
  '/_app/executed-job-details': typeof AppExecutedJobDetailsRoute
  '/_app/library-blank-details': typeof AppLibraryBlankDetailsRoute
  '/_app/library-tool-details': typeof AppLibraryToolDetailsRoute
  '/_app/magazine-slot-details': typeof AppMagazineSlotDetailsRoute
  '/_app/milling-jobs': typeof AppMillingJobsRoute
  '/_app/queued-job-details': typeof AppQueuedJobDetailsRoute
  '/_app/rack-tool-details': typeof AppRackToolDetailsRoute
  '/_app/status': typeof AppStatusRoute
  '/_app/tools': typeof AppToolsRoute
  '/_app/used-tool-details': typeof AppUsedToolDetailsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/active-job-details'
    | '/blanks'
    | '/executed-job-details'
    | '/library-blank-details'
    | '/library-tool-details'
    | '/magazine-slot-details'
    | '/milling-jobs'
    | '/queued-job-details'
    | '/rack-tool-details'
    | '/status'
    | '/tools'
    | '/used-tool-details'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/active-job-details'
    | '/blanks'
    | '/executed-job-details'
    | '/library-blank-details'
    | '/library-tool-details'
    | '/magazine-slot-details'
    | '/milling-jobs'
    | '/queued-job-details'
    | '/rack-tool-details'
    | '/status'
    | '/tools'
    | '/used-tool-details'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/active-job-details'
    | '/_app/blanks'
    | '/_app/executed-job-details'
    | '/_app/library-blank-details'
    | '/_app/library-tool-details'
    | '/_app/magazine-slot-details'
    | '/_app/milling-jobs'
    | '/_app/queued-job-details'
    | '/_app/rack-tool-details'
    | '/_app/status'
    | '/_app/tools'
    | '/_app/used-tool-details'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/used-tool-details': {
      id: '/_app/used-tool-details'
      path: '/used-tool-details'
      fullPath: '/used-tool-details'
      preLoaderRoute: typeof AppUsedToolDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tools': {
      id: '/_app/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof AppToolsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/status': {
      id: '/_app/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof AppStatusRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/rack-tool-details': {
      id: '/_app/rack-tool-details'
      path: '/rack-tool-details'
      fullPath: '/rack-tool-details'
      preLoaderRoute: typeof AppRackToolDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/queued-job-details': {
      id: '/_app/queued-job-details'
      path: '/queued-job-details'
      fullPath: '/queued-job-details'
      preLoaderRoute: typeof AppQueuedJobDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/milling-jobs': {
      id: '/_app/milling-jobs'
      path: '/milling-jobs'
      fullPath: '/milling-jobs'
      preLoaderRoute: typeof AppMillingJobsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/magazine-slot-details': {
      id: '/_app/magazine-slot-details'
      path: '/magazine-slot-details'
      fullPath: '/magazine-slot-details'
      preLoaderRoute: typeof AppMagazineSlotDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/library-tool-details': {
      id: '/_app/library-tool-details'
      path: '/library-tool-details'
      fullPath: '/library-tool-details'
      preLoaderRoute: typeof AppLibraryToolDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/library-blank-details': {
      id: '/_app/library-blank-details'
      path: '/library-blank-details'
      fullPath: '/library-blank-details'
      preLoaderRoute: typeof AppLibraryBlankDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/executed-job-details': {
      id: '/_app/executed-job-details'
      path: '/executed-job-details'
      fullPath: '/executed-job-details'
      preLoaderRoute: typeof AppExecutedJobDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/blanks': {
      id: '/_app/blanks'
      path: '/blanks'
      fullPath: '/blanks'
      preLoaderRoute: typeof AppBlanksRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/active-job-details': {
      id: '/_app/active-job-details'
      path: '/active-job-details'
      fullPath: '/active-job-details'
      preLoaderRoute: typeof AppActiveJobDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppActiveJobDetailsRoute: typeof AppActiveJobDetailsRoute
  AppBlanksRoute: typeof AppBlanksRoute
  AppExecutedJobDetailsRoute: typeof AppExecutedJobDetailsRoute
  AppLibraryBlankDetailsRoute: typeof AppLibraryBlankDetailsRoute
  AppLibraryToolDetailsRoute: typeof AppLibraryToolDetailsRoute
  AppMagazineSlotDetailsRoute: typeof AppMagazineSlotDetailsRoute
  AppMillingJobsRoute: typeof AppMillingJobsRoute
  AppQueuedJobDetailsRoute: typeof AppQueuedJobDetailsRoute
  AppRackToolDetailsRoute: typeof AppRackToolDetailsRoute
  AppStatusRoute: typeof AppStatusRoute
  AppToolsRoute: typeof AppToolsRoute
  AppUsedToolDetailsRoute: typeof AppUsedToolDetailsRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppActiveJobDetailsRoute: AppActiveJobDetailsRoute,
  AppBlanksRoute: AppBlanksRoute,
  AppExecutedJobDetailsRoute: AppExecutedJobDetailsRoute,
  AppLibraryBlankDetailsRoute: AppLibraryBlankDetailsRoute,
  AppLibraryToolDetailsRoute: AppLibraryToolDetailsRoute,
  AppMagazineSlotDetailsRoute: AppMagazineSlotDetailsRoute,
  AppMillingJobsRoute: AppMillingJobsRoute,
  AppQueuedJobDetailsRoute: AppQueuedJobDetailsRoute,
  AppRackToolDetailsRoute: AppRackToolDetailsRoute,
  AppStatusRoute: AppStatusRoute,
  AppToolsRoute: AppToolsRoute,
  AppUsedToolDetailsRoute: AppUsedToolDetailsRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
